/** Pure helpers for co-applicant invite vs Auth0 session mismatch. */

export function normalizeInviteEmail(email?: string | null): string {
  return (email || "").trim().toLowerCase();
}

export function isInviteAuthMismatch({
  authEmail,
  inviteEmail,
}: {
  authEmail?: string | null;
  inviteEmail?: string | null;
}): boolean {
  const auth = normalizeInviteEmail(authEmail);
  const invite = normalizeInviteEmail(inviteEmail);
  if (!auth || !invite) return false;
  return auth !== invite;
}
